import pick from 'lodash/fp/pick';

import config from '@config';

import createDataSource from '../createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from '../utils';

const BASE_PATHNAME = 'filters';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id }) =>
    dataSource.get(`${BASE_PATHNAME}/${id}/${window.localStorage.currentAssetLanguage || 'en'}`).json();

  const getByIds = ({ ids, passErrors }) =>
    Promise.all(
      ids.map(async (id) => {
        try {
          const result = await getById({ id });
          return result;
        } catch (e) {
          // Pass errors so we can show that they were deleted in related content section
          if (passErrors) {
            e.id = id;
            return e;
          }
          throw e;
        }
      }),
    );

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['typeId']),
    }),

    getById,

    getByIds,

    getEmptyList: getDefaultEmptyList,
  };
};
